import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import UserStore from "./store/UserStore";
import {FileStore} from "./store/FileStore";

const userStore = new UserStore();
const fileStore = new FileStore();

export const Context = createContext({userStore, fileStore});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{userStore, fileStore}}>
        <App />
    </Context.Provider>
);
